{
  "appName": "المسافر",
  "platform": "المنصة",
  "name": "الاسم",
  "email": "البريد الإلكتروني",
  "phone": "الهاتف",
  "address": "العنوان",
  "actions": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "create": "إضافة",
    "search": "بحث",
    "retry": "إعادة المحاولة",
    "close": "إغلاق",
    "confirm": "تأكيد"
  },
  "nav": {
    "dashboard": "لوحة التحكم",
    "users": "المستخدمون",
    "settings": "الإعدادات",
    "logout": "تسجيل الخروج"
  },
  "language": {
    "label": "اللغة",
    "ar": "العربية",
    "en": "English",
    "switchTo": {
      "ar": "التبديل إلى العربية",
      "en": "Switch to English"
    }
  },
  "theme": {
    "switchToLight": "التبديل إلى الوضع الفاتح",
    "switchToDark": "التبديل إلى الوضع الداكن"
  },
  "preferences": {
    "label": "إعدادات اللغة والمظهر"
  },
  "state": {
    "loading": "جاري التحميل...",
    "empty": "لا توجد بيانات",
    "error": "تعذر تحميل البيانات. أعد المحاولة."
  },
  "notFound": {
    "title": "الصفحة غير موجودة",
    "description": "تحقق من الرابط، أو عد إلى صفحة يمكنك الوصول إليها.",
    "action": "الذهاب إلى البوابة"
  },
  "sidebar": {
    "toggle": "تبديل الشريط الجانبي",
    "title": "القائمة الجانبية",
    "description": "التنقل بين صفحات النظام"
  },
  "breadcrumb": {
    "label": "مسار التنقل",
    "more": "المزيد"
  },
  "toaster": {
    "label": "الإشعارات"
  },
  "pagination": {
    "label": "التنقل بين الصفحات",
    "morePages": "صفحات أخرى",
    "page": "صفحة {{page}} من {{totalPages}}",
    "total": "{{total}} سجل",
    "next": "التالي",
    "previous": "السابق"
  },
  "combobox": {
    "placeholder": "اختر...",
    "search": "بحث...",
    "empty": "لا توجد نتائج",
    "clearOption": "بدون",
    "clearSelection": "مسح التحديد",
    "removeSelection": "إزالة {{label}}",
    "selectedCount_one": "تم اختيار {{count}} عنصر",
    "selectedCount_two": "تم اختيار {{count}} عنصر",
    "selectedCount_few": "تم اختيار {{count}} عناصر",
    "selectedCount_many": "تم اختيار {{count}} عنصر",
    "selectedCount_other": "تم اختيار {{count}} عنصر"
  },
  "filterToolbar": {
    "phoneCountryCode": "رمز الدولة",
    "toggle": "الفلاتر",
    "resetFilters": "إعادة تعيين الفلاتر"
  },
  "password": {
    "show": "إظهار كلمة المرور",
    "hide": "إخفاء كلمة المرور"
  }
}
